import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { employeeStateSelector } from '~/selectors';

import { EmploymentData } from './types';

export const useEmployeeEmploymentData = (): {
  employeeEmploymentData: EmploymentData[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  const {
    employeeEmploymentData,
    employmentDataLoading,
    employmentDataFailedLoading,
    hasEmploymentData,
  } = useSelector((state: StoreState) => {
    return employeeStateSelector(state);
  });

  return {
    employeeEmploymentData,
    isLoading: employmentDataLoading,
    failedToLoad: employmentDataFailedLoading,
    hasData: hasEmploymentData,
  };
};
